import { KMF_SEND_PURCHASE_EMAIL_CUSTOMER, SEND_LEADS_REQUEST, SEND_UPLOAD_DOCUMENTS, SUBMIT_POLICY_REQUEST, SUBMIT_QUOTE_REQUEST } from "../../../actions/kaMetlhaFuneralCover/policyRequest";
import { KMF_REFERENCE_DATA_SERVICE } from "../../../actions/kaMetlhaFuneralCover/referenceData";
import { leadsMailService } from "./leadsMailService";
import { purchaseMailService } from "./purchaseMailService";
import { purchaseService } from "./purchaseService";
import { quoteService } from "./quoteService";
import { referenceDataService } from "./referenceData";
import { uploadDocumentService } from "./uploadDocumentService";

export const kaMetlhaFuneralCoverServices=(store, next, action)=>{
    if (action.type.startsWith(KMF_REFERENCE_DATA_SERVICE) ) return referenceDataService(store, next, action);
    if (action.type === SEND_UPLOAD_DOCUMENTS) return uploadDocumentService(store, next, action); 
    if (action.type === SUBMIT_POLICY_REQUEST) return purchaseService(store, next, action);
    if (action.type === SUBMIT_QUOTE_REQUEST) return quoteService(store, next, action);
    if (action.type === SEND_LEADS_REQUEST ) return leadsMailService(store,next,action);
    if (action.type === KMF_SEND_PURCHASE_EMAIL_CUSTOMER ) return purchaseMailService(store,next,action);
return null
}
